export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9850.f4fa9ad5.jpg";